import { withProps, compose } from "recompose";
import * as api from "modules/feedback/api";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import * as selectors from "modules/feedback/selectors";
import View from "./View";

export default compose(
  hoc.authorized(isInsider),
  withProps({
    fetchFeedbackApi: api.getCandidateFeedback,
    fetchFeedbackApiSelector: selectors.getCandidateFeedbackApi,
    submitApi: api.submitCandidateFeedback,
    submitApiSelector: selectors.submitCandidateFeedbackApi,
    initialValues: {
      general: ""
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Feedback/Provider.js